export const localEvents = {
  PAWN_DRAG_START: 'pawnDragStart',
  PAWN_DRAG_STOP: 'pawnDragStop',
  PAWN_DRAG_OVER_MOLECULE: 'pawnDragOverMolecule',
  PAWN_DRAG_OUT_MOLECULE: 'pawnDragOutMolecule',
}

export const globalEvents = {
  PAWN_DROPPED_ON_MOLECULE: 'pawnDroppedOnMolecule',
}
